import { LocalizationProvider, TimePicker } from "@mui/lab";
import { Button, Card, Grid, TextField } from "@mui/material";
import React from "react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useState } from "react";
import moment from "moment";
import Swal from "sweetalert2";
import { db } from "hooks";

const ChangeDeliveryConfig = () => {
  const [deliveryTime, setDeliveryTime] = useState([]);

  const [startTime, setStartTime] = useState(
    moment(new Date()).format("HH:mm")
  );
  const [endTime, setEndTime] = useState(moment(new Date()).format("HH:mm"));

  console.log(deliveryTime);

  const handleAdd = () => {
    if (deliveryTime.length > 3) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "You added maximum no of delivery time",
      });
      return;
    }
    setDeliveryTime([...deliveryTime, { startTime, endTime }]);
  };

  const handleSetConfig = async () => {
    try {
      await db.setData("/config/deliverytime", deliveryTime);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Delivery time set successfully",
      });
      setDeliveryTime([]);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Card
        sx={{
          padding: "1rem",
        }}
      >
        <h1
          style={{
            padding: "1rem",
            width: "100%",
            textAlign: "center",
          }}
        >
          Change Delivery Config
        </h1>
        <Grid spacing={3} marginY="1rem" container className="selected-timing">
          {deliveryTime.map((item, index) => {
            return (
              <Grid item xs={12} md={6} key={index} width={"100%"}>
                <TextField
                  value={item?.startTime + " - " + item.endTime}
                  fullWidth
                />
              </Grid>
            );
          })}
        </Grid>
        <h1
          style={{
            padding: "1rem",
            width: "100%",
            textAlign: "center",
          }}
        >
          Add New Delivery Config
        </h1>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TimePicker
                value={moment(startTime, "HH:mm")}
                onChange={(date) => setStartTime(moment(date).format("HH:mm"))}
                renderInput={(params) => <TextField fullWidth {...params} />}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={6}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <TimePicker
                value={moment(endTime, "HH:mm")}
                onChange={(date) => setEndTime(moment(date).format("HH:mm"))}
                renderInput={(params) => <TextField fullWidth {...params} />}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        <div className="w-100 flex-row align-items-center gap-2">
          <Button
            sx={{
              width: "15rem",
              display: "flex",
              marginX: "auto",
              marginTop: "1rem",
              backgroundColor: "#00bcd4",
              color: "#fff",
              ":hover": {
                backgroundColor: "#00bcd4",
                color: "#fff",
              },
            }}
            onClick={handleAdd}
          >
            Add Delivery Config
          </Button>

          <Button
            sx={{
              width: "15rem",
              display: "flex",
              marginX: "auto",
              marginTop: "1rem",
              backgroundColor: "#00bcd4",
              color: "#fff",
              ":hover": {
                backgroundColor: "#00bcd4",
                color: "#fff",
              },
            }}
            onClick={handleSetConfig}
          >
            Set Delivery Config
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default ChangeDeliveryConfig;
